let config = {
	isVanish: false,
  isLogin: true,
  type: 'login',
  pwdPublicKey: `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDlOf8L1Qe0/4hjteRSO6psXldm
  sq7Vv7j6i9LZ9MMhRspdGzlrYiuRXgDCiZYxSMtwSPfCQGIfYbpxwwFN0pVPwaqs
  kFMfxNiKrr6Xv7Z1bVt0mI43W7LioPEl1mllvvmghlx5M1johribJtd2dnwefK48
  A7U36AvvGXLNba2KaQIDAQAB`
  // type: 'invite',
  // type: 'newInvite'
}

export default config


// WEBPACK FOOTER //
// ./src/assets/js/config.js